module.exports = __webpack_public_path__ + "src/assets/games/26/286.jpg";